<template>
  <div class="bg-white header width-full ls-flex-col-center">
    <div class="max-width">
      <div class="flex align-center flex-between mauto" style="padding: 0.5rem 0;">
        <div class="flex flex-column pointer" @click="$router.push({path:'/'})" style="width: 25%;">
          <div class="font-bold fs-20">山西信达农林工程咨询有限公司</div>
          <!-- <span class="" style="font-size: 0.3rem;">Shanxi Xinda agriculture and forestry engineering consulting co., ltd</span> -->
          <!-- <span class="" style="font-size: 0.75rem;text-align: center;">consulting co., ltd</span> -->

        </div>
        <div class="flex flex-between fs-18" style="width: 40%;padding-top: 0.35rem;">
          <div v-for="item in tabList" :key="item.id" @click="selectTab(item)"  :class="{'active': selectedTab === item.id}" class="tab-item">{{ item.name }}</div>
        </div>
        <div class="flex align-center pointer" style="height: 2rem;" @click="$router.push({path:'/search'})">
          <div class="fs-14" style="width: 7rem;color: #959595;border:1px solid #297EF4;height: 100%;line-height: 2rem;padding-left: 0.2rem;">搜索</div>
          <div class="color-white fs-16" style="background: #297EF4;padding:1px 0.45rem;height: 100%;line-height: 2rem;">搜索</div>
        </div>
      </div>
      
    </div>
  </div>
  
</template>
   
<script>
export default {
	data() {
		return { 
      tabList:[
        {id:1,name:'网站首页',path:'home'},
        {id:2,name:'公司概况',path:'company'},
        {id:3,name:'业务范围',path:'yewu'},
        {id:4,name:'新闻资讯',path:'news'},
        {id:5,name:'联系我们',path:'contact'},
      ],
      selectedTab: 1,
		}
	},

  created(){
    
    
  },
  watch: {
    '$route': 'setSelectedTab'
  },
  methods: {
    setSelectedTab() {
      const path = this.$route.path.split('/')[1];
      if (path == 'newsDtl') {
        this.selectedTab = 4; 
      } else if (path == 'search') {
        this.selectedTab = ''; 
      }else{
        const selected = this.tabList.find(tab => tab.path === path);
        this.selectedTab = selected ? selected.id : 1;
      }
    },
    selectTab(item) {
      this.selectedTab = item.id; 
      console.log(item)
      this.$router.push({ path: item.path == 'home' ? '/' : `/${item.path}` });
      // this.$router.push({path:'/' + item.path})
    }
  },
}
</script>

<style scoped lang="scss">
.header{
   position: sticky;
  top: 0;
  z-index: 10;
  background: #fff;
  border-bottom: 1px solid #ccc;
  padding: 0.3rem 0;
}
.tab-item {
  cursor: pointer;
  padding-bottom: 0.6rem;
  // padding: 1.5rem 0;
}

.tab-item.active {
  color: #297EF4; 
  border-bottom: 2px solid #297EF4;
  font-weight: bold;

}
</style>